module.exports = __webpack_public_path__ + "static/telcel-53fa4dcfdf718930f8765a690ac1cd0e.jpg";